import Oidc from "oidc-client";
import EventEmitter from "events";
import { URLS_CONSTANTS } from "../../config.js";

const loginEvent = "loginEvent";

const userManager = new Oidc.UserManager({
  authority: URLS_CONSTANTS.authority,
  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + "/static/silent-renew.html",
  accessTokenExpiringNotificationTime: 60,
  client_id: URLS_CONSTANTS.clientId,
  redirect_uri: URLS_CONSTANTS.redirect_uri,
  response_type: "code",
  scope:
    "openid profile roles businessParties_api geography_api skoruba_identity_admin_api identityAccess_api productManagement_api promotions_api sales_api shipping_api warehouseManagement_api inventories_api middlewareOfAccessToTadbir_api cms_api credits_api notificationManagement_api",
  clockSkew: 1200,
  post_logout_redirect_uri: URLS_CONSTANTS.post_logout_redirect_uri,
  userStore: new Oidc.WebStorageStateStore({ store: window.localStorage })
});

class AuthService extends EventEmitter {
  profile = null;
  tokenExpiry = null;

  getProfile() {
    let self = this;
    return new Promise((resolve, reject) => {
      userManager
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user.profile);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  getUser() {
    let self = this;
    return new Promise((resolve, reject) => {
      userManager
        .getUser()
        .then(function(user) {
          if (user == null) {
            self.signIn();
            return resolve(null);
          } else {
            return resolve(user);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  logOut() {
    localStorage.removeItem("permissions");
    userManager.signoutRedirect();
    this.emit(loginEvent, { loggedIn: false });
  }

  getAccessToken() {
    return new Promise((resolve, reject) => {
      userManager
        .getUser()
        .then(user => {
          resolve(user.access_token);
        })
        .catch(error => reject(error));
    });
  }

  getSignedIn() {
    let self = this;
    return new Promise((resolve, reject) => {
      userManager
        .getUser()
        .then(function(user) {
          if (user == null || user.expired) {
            self.signIn();
            return resolve(false);
          } else {
            return resolve(true);
          }
        })
        .catch(function(err) {
          console.log(err);
          return reject(err);
        });
    });
  }

  signIn() {
    userManager.signinRedirect().catch(function(err) {
      console.log(err);
    });
  }
}

export default new AuthService();
